module.exports = __webpack_public_path__ + "static/media/service_temp_1.88fc4dfc.jpg";